import Interceptor from "@/plugins/interceptor.js";

const urlAPI = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GAME_STATUS}`;

const GameStatus = {
  state: {},
  actions: {
    pending: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/pending`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    beforeMatch: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/beforeMatch`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    firstHalf: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/firstHalf`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    halftime: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/halftime`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    secondHalf: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/secondHalf`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    penalties: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/penalties`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    extraTime: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/extraTime`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    finalize: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/finalize`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    }
  },
  mutations: {}
};

export default GameStatus;